import { createSelector } from '@app/utils/createSelector'
import { normalizeSafe } from '@app/utils/normalizer'

import type { ApiPublicParentReview } from '@app/packages/api/v2/types/entities'
import type { GetReviewsPublicFromParentsQuery } from '@app/packages/api/v2/types/params'

import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

const publicParentReviewsSlice = createReduxSlice<{ [key: string]: ApiPublicParentReview }>('public_parent_reviews')
const publicParentReviewsMetaSlice = createReduxSlice<PublicParentReviewsMeta>('public_parent_reviews_meta')

export const addPublicParentReviewsPageSlice = (query: GetReviewsPublicFromParentsQuery, resp: { data: ApiPublicParentReview[] }) =>
  createThunk(dispatch => {
    dispatch(
      publicParentReviewsSlice.update(state => {
        const { public_parent_reviews } = normalizeSafe<ApiPublicParentReview>(resp)
        if (!public_parent_reviews) return state
        return { ...state, ...public_parent_reviews }
      })
    )
    dispatch(
      publicParentReviewsMetaSlice.set({
        page: query.page,
        per_page: query.per_page,
        fetching: false,
        fetched_all: resp.data.length < query.per_page,
      })
    )
  })

export const startPublicParentReviewsPageSlice = () => publicParentReviewsMetaSlice.update(state => ({ ...(state ?? DEFAULT_META), fetching: true }))

export const failPublicParentReviewsPageSlice = () => publicParentReviewsMetaSlice.update(state => ({ ...(state ?? DEFAULT_META), fetching: false }))

export const publicParentReviewsModelsSelector = createSelector([publicParentReviewsSlice.selector], reviews => reviews ?? {})

export const publicParentReviewsMetaSelector = createSelector([publicParentReviewsMetaSlice.selector], meta => meta ?? DEFAULT_META)

type PublicParentReviewsMeta = {
  page: number
  per_page: number
  fetching: boolean
  fetched_all: boolean
}

const DEFAULT_META: PublicParentReviewsMeta = {
  page: 0,
  per_page: 10,
  fetching: false,
  fetched_all: false,
}
